import { Routes } from '@angular/router';
import { AuthGuard } from './services/auth.guard';
var ɵ0 = function () { return import("./tab1/tab1.module.ngfactory").then(function (m) { return m.Tab1PageModuleNgFactory; }); }, ɵ1 = function () { return import("./tab2/tab2.module.ngfactory").then(function (m) { return m.Tab2PageModuleNgFactory; }); }, ɵ2 = function () { return import("./tab3/tab3.module.ngfactory").then(function (m) { return m.Tab3PageModuleNgFactory; }); }, ɵ3 = function () { return import("./tab4/tab4.module.ngfactory").then(function (m) { return m.Tab4PageModuleNgFactory; }); }, ɵ4 = function () { return import("./scheduler/scheduler.module.ngfactory").then(function (m) { return m.SchedulerPageModuleNgFactory; }); }, ɵ5 = function () { return import("./settings/settings.module.ngfactory").then(function (m) { return m.SettingsPageModuleNgFactory; }); }, ɵ6 = function () { return import("./auth/auth.module.ngfactory").then(function (m) { return m.AuthModuleNgFactory; }); };
var routes = [
    { path: '', redirectTo: 'tab1', pathMatch: 'full' },
    { path: 'tab1', loadChildren: ɵ0, canActivate: [AuthGuard] },
    { path: 'tab2', loadChildren: ɵ1, canActivate: [AuthGuard] },
    { path: 'tab3', loadChildren: ɵ2, canActivate: [AuthGuard] },
    { path: 'tab4', loadChildren: ɵ3 },
    // Auth is enforced inside Scheduler module to allow /scheduler/embedded without app login
    { path: 'scheduler', loadChildren: ɵ4 },
    { path: 'settings', loadChildren: ɵ5, canActivate: [AuthGuard] },
    { path: 'auth', loadChildren: ɵ6 },
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6 };
